import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=139a694b&scoped=true&"
import script from "./VideoGallery.vue?vue&type=script&lang=ts&"
export * from "./VideoGallery.vue?vue&type=script&lang=ts&"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=139a694b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a694b",
  null
  
)

export default component.exports